import React, { useState, useEffect } from "react";
import { pb4y as api } from "../../../../services/apis";
import { producaov2 as api2 } from "../../../../services/apis";
import { Button, Form, Dropdown, Loader } from "semantic-ui-react";
import * as yup from "yup";
import { toast } from "react-toastify";

import {
  Container,
  Content,
  Title,
  LabelTitle,
  Label,
  Image,
  Field,
  Div,
  Div2,
} from "./styles";

import swal from "sweetalert";
import { Link, withRouter } from "react-router-dom";
import AdminMenu from "../../../../components/Admin/MenuDetalhes/AdminMenu";
import { isAuthAdmin } from "../../../../services/auth";

const PocketDia = (props) => {
  const [pocketDia, setPocketDia] = useState("");
  const [pockets, setPockets] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    loadAuth();
    loadPocket();
  }, []);
  const loadAuth = async () => {
    const auth = await isAuthAdmin();

    if (!auth) {
      localStorage.setItem("redirect", `/admin/`);
      window.location.href = "/login";
      return null;
    }
  };

  const loadPocket = async () => {
    await api
      .get(`pocketbooks?lang=all`)
      .then((res) => {
        const newArray = res.data.map((artigo) => ({
          key: artigo.id,
          value: artigo.url,
          text: artigo.titulo,
        }));
        setPockets(newArray);
        setLoading(false);
      })
      .catch((err) => {
        swal("Não foi possível carregar os artigos", err, "error");
        setLoading(false);
      });
  };

  const create = async () => {
    const payload = {
      url: pocketDia,
    };
    const postValidation = await yup.object().shape({
      url: yup
        .string("Necessário que informe o artigo")
        .required("Necessário que informe o artigo"),
    });

    try {
      await postValidation.validate(payload, { abortEarly: true });
      api
        .put(`PostDoDia/1`, payload)
        .then(async (res) => {
          let logs = {
            local: "PocketBook/pocketDia",
            texto: `editou o pocket do dia`,
          };
          await api2.post("system_logs", { acao: JSON.stringify(logs) });
          swal(
            " Pocket do dia atualizado com sucesso",
            "",
            "success"
          ).then((res) => props.history.push("/admin/blog/pocketbook4you"));
        })
        .catch((err) => {
          swal(
            "Não foi possível atualizar o pocket do dia",
            err,
            ""
          ).then((res) => props.history.push("/admin/blog/pocketbook4you"));
        });
    } catch (err) {
      if (err instanceof yup.ValidationError) {
        swal("Erro!", `${err}`, "error");
        return;
      }
    }
  };
  return (
    <>
      <Container>
        <AdminMenu />
        {loading ? (
          <Loader active inline="centered" size="massive" />
        ) : (
          <Content>
            <Title>PocketBook dos Dia</Title>

            <Form>
              <Form.Group widths="equal">
                <Form.Field>
                  <Label>Linguagem</Label>
                  <Dropdown
                    placeholder="Selecione o artigo"
                    fluid
                    search
                    selection
                    options={pockets}
                    onChange={(e, data) => setPocketDia(data.value)}
                  />
                </Form.Field>
              </Form.Group>
              <Form.Group>
                <Form.Field
                  control={Button}
                  onClick={() => {
                    create();
                  }}
                >
                  Salvar PocketBook do dia
                </Form.Field>
                <Link to="/admin/blog/pocketbook4you/">
                  <Button color="secondary">Cancelar</Button>
                </Link>
              </Form.Group>
            </Form>
          </Content>
        )}
      </Container>
    </>
  );
};

export default withRouter(PocketDia);
